import {Fill, Icon, Stroke, Style, Text} from "ol/style";
import {config} from "../../config";

// url from utilities
const url = (path = "") => {
    return `${config('app.host')}${config('app.base_path')}/${path}`;
}

export const observationsStyle = (feature) => {
    let type = window._inventory_type ?? -1;

    let icon = url(`images/obserwacja.png`);

    if(feature.get('selected') ?? false) {
        icon = url(`images/observer-marker-active.png`)
    }

    if(parseInt(type) === 4 && feature.get('data')) {
        icon = url(`images/settlement-marker-not-inspected.png`)
        let item = feature.get('data').items[0];

        if(parseInt(item.is_inspected) === 1) {
            // icon = url(`images/settlement-marker-inspected.png`)
            icon = url(`images/settlement-marker-settled.png`)

            // if(parseInt(item.settlement_type) === 1) {
            //     icon = url(`images/settlement-marker-settled.png`)
            // }
        }
    }

    if(parseInt(type) === 5 && feature.get('data')) {
        let observation = feature.get('data');

        if(parseInt(observation.thermal_imaging_area_type) === 2) {
            icon = url(`images/thermal-imaging-field.png`)
        } else {
            icon = url(`images/thermal-imaging-forest.png`)
        }
    }

    let text = '';
    if(feature.get('data') ?? null) {
        text = feature.get('data').number ?? ''
    }

    return new Style({
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: text.toString(),
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'black', width: 2}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: 'overflow',
        }),
        image: new Icon({
            src: icon,
            anchor: [0.5, 0.5],
            scale: [0.3, 0.3]
        }),
    })
}
